import { fromJS } from 'immutable';
import * as Handlers from '#base/Canvas/ReducerActions.js';

const debug = true;

export const reducerFactory = (config) => (state, action) => {
  if (config[action.type]) {
    const newState =  config[action.type](state, action);
    debug && console.log('DESIGNER ACTION', action.type, { action, state, newState });
    return newState
  } else {
    debug && console.log('UNHANDLED DESIGNER ACTION', action.type, { action });
    return state;
  }
};

export const reducer = reducerFactory(Handlers);

export const initialState = fromJS({
  faces: [],
  selectedFace: null,
  assetLibrary: {},
});
